import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import { InstallPrompt } from "@/components/InstallPrompt";
import Home from "@/pages/Home";
import About from "@/pages/About";
import TheProject180 from "@/pages/TheProject180";
import Library from "@/pages/Library";
import YouthLeaders from "@/pages/YouthLeaders";
import GetInvolved from "@/pages/GetInvolved";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 font-body">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function MembersOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 font-body">Loading…</div>;
  if (!user) return <Navigate to="/signup?redirect=/library" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <Toaster position="top-right" />
            <InstallPrompt />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/the-180-project" element={<TheProject180 />} />
                <Route path="/library" element={<MembersOnly><Library /></MembersOnly>} />
                <Route path="/youth-leaders" element={<YouthLeaders />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/get-involved" element={<GetInvolved />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              </Routes>
            </Layout>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
